import { api } from './api';
import { getLocalDate } from '../utils/date-utils';
import type { ProgressResponse, ProgressUpdateInput, ProgressType } from '@xdface-vault/shared';

export type { ProgressResponse };

export interface UpsertProgressInput extends ProgressUpdateInput {
  type: ProgressType;
  slug: string;
  title: string;
}

export interface ListProgressParams {
  status?: string;
}

export const progressApi = {
  listProgress: (params?: ListProgressParams): Promise<ProgressResponse[]> => {
    const queryParams: Record<string, string> = {};
    if (params?.status) queryParams.status = params.status;
    return api
      .get<{
        items: ProgressResponse[];
        count: number;
      }>('/progress', Object.keys(queryParams).length > 0 ? queryParams : undefined)
      .then((r) => r.items ?? []);
  },

  upsertProgress: (input: UpsertProgressInput): Promise<ProgressResponse> => {
    return api.post<ProgressResponse>('/progress', { ...input, localDate: getLocalDate() });
  },

  getProgressBySlug: (type: string, slug: string): Promise<ProgressResponse> => {
    return api.get<ProgressResponse>(`/progress/${type}/${slug}`);
  },
};
